/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorissuesectionwithouttitle5Inputs */

const en_menueditorissuesectionwithouttitle5 = /** @type {(inputs: Menueditorissuesectionwithouttitle5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A section with dishes has no title yet.`)
};

const de_menueditorissuesectionwithouttitle5 = /** @type {(inputs: Menueditorissuesectionwithouttitle5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bereich mit Gerichten hat noch keinen Titel.`)
};

/**
* | output |
* | --- |
* | "A section with dishes has no title yet." |
*
* @param {Menueditorissuesectionwithouttitle5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorissuesectionwithouttitle5 = /** @type {((inputs?: Menueditorissuesectionwithouttitle5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorissuesectionwithouttitle5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorissuesectionwithouttitle5(inputs)
	return de_menueditorissuesectionwithouttitle5(inputs)
});
export { menueditorissuesectionwithouttitle5 as "menuEditorIssueSectionWithoutTitle" }